<template>
  <el-col :lg="8" :sm="24" class="item">
    <p class="title">{{queue.name}}</p>
    <el-tooltip :disabled="percent <= 0">
      <div slot="content">
        Proporción de comparación con las otras colas: {{percent.toFixed(2)}} %
      </div>
      <el-progress :percentage="percent"
                   :color="progressColor"
                   :show-text="false"/>
    </el-tooltip>
    <p class="quantity">
      <span>{{queue.len}}</span>
      <span>{{queue.unit}}</span>
    </p>
    <div class="rates">
      <Rates :rates="queue.rates"/>
    </div>
  </el-col>
</template>

<script>
import Rates from './Rates.vue';

export default {
  props: {
    queue: {
      type: Object,
      default() {
        return {};
      },
    },
    maxLen: {
      type: Number,
      default: 0,
    },
  },
  name: 'Item',
  components: {
    Rates,
  },
  data() {
    return {
      progressColor: '#cccccc',
    };
  },
  computed: {
    percent() {
      return this.maxLen === 0 ? 0 : this.queue.len / this.maxLen * 100;
    },
  },
};
</script>

<style lang="scss" scoped>
  .item {
    .title {
      color: $fb-green;
      font-size: 17px;
      font-weight: 800;
      margin: 20px 0 5px;
      text-transform: uppercase;
    }
    .quantity {
      float: left;
      display: flex;
      text-align: left;
      margin-top: -5px;
      span { color: $fb-grey-light-30; }
      span:first-child {
        font-size: 48px;
        font-weight: 300;
        margin-right: 2px;
      }
      span:last-child {
        font-size: 12px;
        line-height: 3.4;
        font-weight: 300;
        vertical-align: top;
        text-transform: uppercase;
      }
    }
    .rates {
      float: right;
      display: flex;
    }
  }
</style>
